<template>
  <div class="conversation-item-time">
    <i></i>
    <p>{{formatMessageTime(item.content.timestamp||0)}}</p>
    <i></i>
  </div>
</template>
<script>
  import {
    reactive,
    onMounted,
  } from 'vue'
  import {
    useRouter
  } from 'vue-router'
  // import {
  //   Toast
  // } from 'vant'
  import {
    useStore
  } from "vuex"
  import moment from 'moment';


  export default {
    name: 'conversationitemtime',
    props: ['item'],
    setup() {
      const store = useStore()

      const router = useRouter()
      const state = reactive({
        uid: store.state.imuid,
      })
      const formatMessageTime = (timestamp) => {
        return moment(timestamp * 1000).format('MM月DD日');
      }
      onMounted(() => {

      })

      // 返回
      const onClickLeft = () => {
        router.back()
      }



      return {
        state,
        onClickLeft,
        formatMessageTime
      }
    }
  }
</script>
<style scoped="scoped">
  .conversation-item-time {
    padding: 20px 0;
    margin-bottom: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .conversation-item-time p {
    font-size: 24px;
    text-align: center;
    color: #666;
    margin: 0 20px;
  }
  .conversation-item-time i{
    width: 200px;
    height: 1px;
    background-color: #eee;
  }
</style>